<template>
  <modal-box
    class="cakelp-farming-harvest-modal"
    :title="`$${this.harvest.stakingPool.rewardTokenSymbol} Harvest`"
  >
    <template #body>
      <p class="harvest">
        <span class="label">Harvesting</span>
        <em class="num">{{
          toFormattedToken(harvest.stakingPool.account.earned)
        }}</em>
        <span class="unit">{{ harvest.stakingPool.rewardTokenSymbol }}</span>
      </p>
    </template>

    <template #footer>
      <input-button
        :size="'large'"
        :is-loading="isLoading"
        :disabled="harvest.stakingPool.account.earned <= 0"
        @click="onConfirm"
        >{{ isLoading ? "Confirming" : "Confirm" }}</input-button
      >
      <text-link class="clsoe-link" @click="closeModal">Close window</text-link>
    </template>
  </modal-box>
</template>

<script>
import TextLink from "@/components/atoms/TextLink";
import InputButton from "@/components/atoms/InputButton";
import ModalBox from "@/components/molecules/ModalBox";
import { getPools } from "@/utils/cakeLpFarming";
import cakeLpFarmingPools from "@/domain/cakeLpFarming/pools";
import numFormat from "number-format.js";

export default {
  name: "CakelpFarmingHarvesttModal",
  components: {
    InputButton,
    TextLink,
    ModalBox,
  },
  data() {
    return {
      isLoading: false,
      checkStatusInterval: null,
    };
  },
  computed: {
    harvest() {
      return this.$store.state.harvest;
    },
    account() {
      return this.$store.state.account;
    },
    web3() {
      return this.$store.state.web3;
    },
  },
  methods: {
    toFormattedToken(num) {
      return numFormat(
        "#,##0.00000",
        this.web3.instance.utils.fromWei(num, "ether")
      );
    },
    onConfirm() {
      this.isLoading = true;

      const amount = this.web3.instance.utils.toWei(
        this.web3.instance.utils.toBN(0).toString(),
        "ether"
      );

      const abi = cakeLpFarmingPools.find(
        (pool) =>
          pool.contractAddress == this.harvest.stakingPool.stakeContractAddress
      ).abi;

      const stakingPoolContract = new this.web3.instance.eth.Contract(
        abi,
        this.harvest.stakingPool.stakeContractAddress
      );

      stakingPoolContract.methods
        .withdraw(amount)
        .send({ from: this.account.address })
        .on("transactionHash", (transactionHash) => {
          this.checkTransactionStatus(transactionHash, 10);
        })
        .on("error", () => {
          this.incompleteTransaction();
        });
    },
    checkTransactionStatus(transactionHash, seconds) {
      this.checkStatusInterval = setInterval(() => {
        this.web3.instance.eth
          .getTransactionReceipt(transactionHash)
          .then((result) => {
            if (result) {
              if (result.status) {
                clearInterval(this.checkStatusInterval);
                this.completeTransaction();
              }
            }
          });
      }, seconds * 1000);
    },
    completeTransaction() {
      getPools(this.web3.instance, this.account.address).then((result) => {
        this.$store.dispatch("cakeLpFarmings/updatePools", result);

        this.isLoading = false;
        this.$store.dispatch("closeModal");

        this.$store.dispatch("toast/updateToast", {
          type: "success",
          title: "Harvested!",
          message: `Your ${this.harvest.stakingPool.rewardTokenSymbol} earnings have been sent to your wallet!`,
        });
      });
    },
    incompleteTransaction() {
      this.isLoading = false;
      this.$store.dispatch("closeModal");

      this.$store.dispatch("toast/updateToast", {
        type: "error",
        title: "Error",
        message:
          "Please try again. Confirm the transaction and make sure you are paying enough gas!",
      });
    },
    closeModal() {
      this.$store.dispatch("closeModal");
    },
  },
  beforeDestroy() {
    clearInterval(this.checkStatusInterval);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.cakelp-farming-harvest-modal {
}
.harvest {
  display: grid;
  font-weight: 600;
  grid-gap: 24px 16px;
  grid-template-columns: 1fr auto;

  @include media(pc) {
    font-size: 2.7rem;
  }
  @include media(sp) {
    font-size: 2.2rem;
  }
  .label {
    grid-row: 1;
    grid-column: 1 / 3;
  }
  .num {
    font-weight: 700;
    grid-column: 1;
    text-align: right;
  }
  .unit {
    grid-column: 2;
  }
}
.clsoe-link {
  margin-top: 24px;

  @include media(pc) {
    font-size: 1.7rem;
  }
  @include media(sp) {
    font-size: 1.4rem;
  }
}
</style>